import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import HeaderClient from './HeaderClient';
import LoginSessions from './LoginSessions';

const ParticipantsBackEnd = () => {
  return (
    <Container fluid>
      <Row>
        <HeaderClient />
      </Row>
      <Row>
        <Col>
          <LoginSessions embedded={true} />
        </Col>
      </Row>
    </Container>
  );
};

export default ParticipantsBackEnd;
